// istanbul ignore file
import { createGlobalStyle } from 'styled-components';

const FONT_STACK = "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif";

export const GlobalStyle = createGlobalStyle`
    *, *::before, *::after { box-sizing: border-box; }

    html, body, #root { height: 100%; }
    html { font-size: 16px; }

    /* Slimmer scrollbar (Firefox + WebKit): default classic scrollbars on Windows render
       much wider than macOS overlay scrollbars, so the app shell looks inconsistent
       across platforms without this. */
    html {
        scrollbar-width: thin;
    }
    ::-webkit-scrollbar {
        width: 6px;
    }

    body {
        margin: 0;
        padding: 0;
        font-family: ${({ theme }) => (theme as { uiBricks?: Record<string, string> }).uiBricks?.primaryFontFamily ?? FONT_STACK};
        font-size: 16px;
        line-height: 22px;
    }

    .bridge-bar-menu-overlay { display: none !important; }

    .interstate-reference {
        z-index: 1300 !important; // @TODO: TA2381111 - waiting for the fix (interstate)
    }

    .header-root {
        background-color: #fff
    }

    // Bootstrap gets loaded dynamically in Trade-In Page and after that theme load
    // every label in the app takes a +5px on margin bottom. 
    // Keeping this margin bottom 0 (same as MV with CX) would keep consistent the whole page.
    [data-testid='unified-customer-card'] label {
        margin-bottom: 0;
    }

    // SCI lacks MV's Cx theming, so the date input sits lower than the shared MaskDatePicker overlay's
    // fixed offsets expect; thats why we need this specific override.
    [data-testid$='drivers-license-expiration-date-overlay'],
    [data-testid$='date-of-birth-overlay'] {
        top: 2rem !important;
    }
`;
